export const breakpoints = {
  base: "0em",
  sm: "30em", // ~480px.
  "2sm": "36em", //~576px
  md: "48em", // ~768px
  lg: "62em", // ~992px
  "2lg": "64em", // ~1024px
  xl: "80em", // ~1280px
  "2xl": "96em", // ~1536px
};
